module.exports = __webpack_public_path__ + "static/img/sexual_violence.964361d2.png";